import { NgModule } from '@angular/core';
@NgModule({
  declarations: [],
  imports: [],
  providers: [],
  bootstrap: [],
})
export class ServicesModule {}
